<template>
  <view-with-location>
    <v-container
      class="pa-0"
      :class="isMobile ? 'pt-9' : 'px-0'"
    >
      <!-- LAGER LEER -->
      <v-container
        v-if="
          !tireStorage.totalAccumulatedTires &&
          locationDetail.showTireStorage &&
          !isLoading
        "
        class="text-center infoBox"
        fill-height
      >
        <v-row align="center" justify="center">
          <v-col cols="12" sm="4">
            <storage-empty />
            <p class="font-weight-bold mt-10">Dieses Lager ist noch leer</p>
            <p class="font-size-small">Bitte pflegen Sie hier den Altreifenbestand.</p>
          </v-col>
        </v-row>
      </v-container>

      <!-- KEIN LAGER -->
      <v-container
        v-if="locationDetail.id && !locationDetail.showTireStorage"
        class="text-center infoBox"
        fill-height
      >
        <v-row align="center" justify="center">
          <v-col cols="12" sm="4">
            <storage-unavail />
            <p class="font-weight-bold mt-10">
              Für diesen Standort gibt es kein Altreifenlager
            </p>
            <p class="font-size-small">Bitte wählen Sie einen anderen Standort.</p>
          </v-col>
        </v-row>
      </v-container>

      <!-- LAGERBESTAND -->
      <v-container class="mt-6" :class="!isMobile ? 'px-2' : ''">
        <v-card rounded>
          <v-simple-table
            v-if="locationDetail.showTireStorage && tireStorage.totalAccumulatedTires"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Reifen-Art</th>
                  <th class="text-center">Anzahl</th>
                  <th class="text-right">Wert</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>unvergütet</td>
                  <td class="text-center">{{ tireStorage.belowTwoMm.amount }}</td>
                  <td class="text-right">
                    {{
                      (tireStorage.belowTwoMm.accumulatedCredit / 100).toLocaleString(
                        "de-DE",
                        {
                          style: "currency",
                          currency: "EUR",
                        }
                      )
                    }}
                  </td>
                </tr>

                <tr>
                  <td>Qualität AF</td>
                  <td class="text-center">{{ tireStorage.twoMm.amount }}</td>
                  <td class="text-right">
                    {{
                      (tireStorage.twoMm.accumulatedCredit / 100).toLocaleString(
                        "de-DE",
                        {
                          style: "currency",
                          currency: "EUR",
                        }
                      )
                    }}
                  </td>
                </tr>

                <tr>
                  <td>Qualität P</td>
                  <td class="text-center">{{ tireStorage.threeMm.amount }}</td>
                  <td class="text-right">
                    {{
                      (tireStorage.threeMm.accumulatedCredit / 100).toLocaleString(
                        "de-DE",
                        {
                          style: "currency",
                          currency: "EUR",
                        }
                      )
                    }}
                  </td>
                </tr>

                <tr>
                  <td>Qualität GP</td>
                  <td class="text-center">{{ tireStorage.fiveMm.amount }}</td>
                  <td class="text-right">
                    {{
                      (tireStorage.fiveMm.accumulatedCredit / 100).toLocaleString(
                        "de-DE",
                        {
                          style: "currency",
                          currency: "EUR",
                        }
                      )
                    }}
                  </td>
                </tr>

                <tr>
                  <th class="text-body-2 font-weight-bold">Summe aller Reifen</th>
                  <th class="text-center text-body-2 font-weight-bold">
                    {{ tireStorage.totalAccumulatedTires }}
                  </th>
                  <th class="text-right text-body-2 font-weight-bold">
                    {{
                      (tireStorage.totalAccumulatedCredit / 100).toLocaleString("de-DE", {
                        style: "currency",
                        currency: "EUR",
                      })
                    }}
                  </th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <v-row justify="center">
          <v-btn
            class="mt-7 mr-2"
            color="primary"
            outlined
            :to="{ name: 'Agreements' }"
            v-if="tireStorage.totalAccumulatedTires"
            rounded
            style="
              background-color: white;
              min-height: 40px !important;
              width: 210px !important;
              font-weight: 500 !important;
            "
            >Entsorgung beauftragen</v-btn
          >
          <tire-add
            v-if="locationDetail.id && locationDetail.showTireStorage"
            :tires="tires"
            :locationName="locationDetail.displayName"
          />
        </v-row>
      </v-container>
    </v-container>
  </view-with-location>
</template>

<script>
import ViewWithLocation from "@/components/ViewWithLocation.vue";
import StorageEmpty from "@/components/svg/StorageEmpty";
import StorageUnavail from "@/components/svg/StorageUnavail";

import TireAdd from "@/components/TireAdd";
import { mapState } from "vuex";
export default {
  name: "Tires",
  components: {
    ViewWithLocation,
    TireAdd,
    StorageEmpty,
    StorageUnavail,
  },
  mounted() {
    this.$store.dispatch("getTires").catch((err) => {
      this.$toast.error(err.response.data.error.message);
    });
    if (this.locationDetail.id) {
      this.$store.dispatch("getTireStorage", this.locationDetail.id).catch((err) => {
        this.$toast.error(err.response.data.error.message);
      });
    }
  },
  methods: {},
  computed: {
    ...mapState({
      locationDetail: (state) => state.company.locationDetail,
      tires: (state) => state.tire.tires,
      tireStorage: (state) => state.tire.tireStorage,
      isLoading: (state) => state.app.isLoading,
    }),
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
  },
  watch: {
    locationDetail({ showTireStorage, id }) {
      if (showTireStorage) {
        this.$store.dispatch("getTireStorage", id);
      }
    },
  },
};
</script>
<style lang="sass">
svg
  max-width: 200px
.infoBox
  min-height: 400px
</style>
